import React from 'react'
import { Link } from 'react-router-dom';
// assets
import Particles from 'react-particles-js';
import ParticleConfig from '../../assets/config/particle-config'
import '../../assets/css/home.min.css'
//Components
import Header from '../../components/headerComponent/header'
import Footer from '../../components/footerComponent/footer'


function HomeC() {
    return (
      <div className="home-screen">
      <Header/> 
            <div className='content'>
                  
                  <div className='col-sm-6'>
                      <h2 className='text'>Soft Matter</h2>
                    
                      <Link to="/post/1627772400"> <h1 className="display-2">Physics</h1></Link>
                      <p className="h6 paraone">
                        Recently, I worked in a voluntary internship for a month in Soft Matter Physics in School of Physics and Astrononmy in University of Edinburgh. 
                      The project revolved around finding a reliable method for particle sizing in Multi-modal suspensions.
                      <hr></hr>
                      <Link to="/post/1627772400"> Read More ></Link>
                      </p>

                 
                  </div>
                  </div>
               <Footer/>
               <Particles className="particleContainer" params={ParticleConfig} />
               </div>
    )
}

export default HomeC
